const forceUseLocalhost = false
export let BASE_URL = ''

if (forceUseLocalhost && process.env.NODE_ENV === 'development') {
    BASE_URL = 'http://localhost:8000/'
} else {
    BASE_URL = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging' ? 'https://test-api.beatpulse.app/' : 'https://api.beatpulse.app/'
}
